import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";


const useStyle = makeStyles((theme) => ({
    mainColumn: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        width: "100%",
        alignSelf: "center",
    },
    mainRows: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        width: "85%",
        marginTop: "4px",
        marginBottom: "4px",
        alignSelf: "center",
    },
    progressBarContainer: {
        display: "flex",
        flexDirection: "row",
        width: "100%",
    },

    progressBarTextFilled: {
        fontSize: "16px",
        width: "136px",
        textAlign: "center",
        color: "#bb0d66",
        fontFamily: "EncodeSansBold",
        transition: "0.2s all linear",
    },

    progressBarText: {
        width: "136px",
        fontFamily: "EncodeSansBold",
        textAlign: "center",
        fontSize: "16px",
        color: "#9a9a9a",
    },

    progressBarCircleFilled: {
        width: "25px",
        height: "25px",
        backgroundColor: "#bb0d66",
        borderRadius: "50%",
        fontWeight: "bold",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        transition: "0.2s all linear",
        fontSize: "14px",
        color: "#FFF",
        textAlign: "center"
    },

    progressBarCircle: {
        width: "25px",
        height: "25px",
        backgroundColor: "#9a9a9a",
        borderRadius: "50%",
        fontWeight: "bold",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        fontSize: "14px",
        color: "#FFF",
        textAlign: "center"
    },

    progressBarSection: {
        background: "#9a9a9a",
        height: "3px",
        top: "8px",
    },

    progressBarSectionFilled: {
        background: "#bb0d66",
        height: "3px",
        top: "8px",
        transition: "0.2s all linear",
    },

    barSeparator: {
        borderLeft: "2px solid #9a9a9a",
        height: "15px",
        marginTop: "-6px",
    },

    barSpacing: {
        height: "15px",
        width: "15%",
    },

    barSpacing2: {
        height: "15px",
        width: "12%",
    },

    barSeparatorFilled: {
        borderLeft: "2px solid #bb0d66",
        height: "15px",
        marginTop: "-6px",
    },

}))

const ProgressBarMobile = (props) => {
    const classes = useStyle();
    const step = props.activeStep;
    const titles = props.stepTitles;
    const barLenght = props.stepTitles.length;
    let isCompleted = [false, false, false, false, false, false]

    switch (step) {
        case 0:
            isCompleted = [true, false, false, false, false, false]
            break;
        case 1:
            isCompleted = [true, true, false, false, false, false]
            break;
        case 2:
            isCompleted = [true, true, true, false, false, false]
            break;
        case 3:
            isCompleted = [true, true, true, true, false, false]
            break;
        case 4:
            isCompleted = [true, true, true, true, true, false]
            break;
        case 5:
            isCompleted = [true, true, true, true, true, true]
            break;
        case 6:
            isCompleted = [true, true, true, true, true, true]
            break;
    }

    const circleNumbersCreator = (amount) => {
        let circleNumbers = [];
        for (let i = 0; i < amount; i++) {
            circleNumbers.push(
                <div
                    className={isCompleted[i]
                        ? classes.progressBarCircleFilled
                        : classes.progressBarCircle
                    }>
                    {i + 1}
                </div>
            )
        }
        return circleNumbers;
    }

    const titlesCreator = (step) => {
        let titlesDOM = [];
        titlesDOM.push(
            <div className={classes.progressBarTextFilled}>
                {titles[step]}
            </div>
        )
        return titlesDOM;
    }

    return (
        <React.Fragment>
            <div className={classes.mainColumn}>
                <div className={classes.mainRows}>
                    {circleNumbersCreator(barLenght)}
                </div>
                <div className={classes.mainRows}>
                    {titlesCreator(step)}
                </div>
            </div>
        </React.Fragment>
    );
};

export default ProgressBarMobile;
